import { useEffect, useRef } from 'react'
import styles from './Confetti.module.scss'


type Props = {
  gameState: 'guessing' | 'success' | 'failure',
  alwaysFire?: boolean
  // Where to remember what confetti was last shot for, and what this one is for. Defaults to once per spellify number
  lastFiredKey?: string
  fireId?: string
}

const Confetti: React.FC<Props> = ({gameState, alwaysFire, lastFiredKey = 'spellifyLastConfetti', fireId}: Props) => {

  const confettiContainer = useRef<HTMLSpanElement>(null)

  const handleConfetti = () => {
    if (!confettiContainer.current) return

    confettiContainer.current.classList.add(styles.explosion)
    confettiContainer.current.addEventListener('animationend', () => {
      confettiContainer.current?.classList.remove(styles.explosion)
    }, {once: true})
  }

  useEffect(() => {
    // Only mark an id as celebrated once we actually celebrate it. The end modal can re-render with the
    // next puzzle's id while it animates closed, and marking it then would eat that puzzle's confetti.
    if (gameState !== 'success') return
    if (!alwaysFire){
      const lastConfettiShotFor = localStorage.getItem(lastFiredKey)
      const currentId = fireId ?? localStorage.getItem('spellifyNumber')
      if (lastConfettiShotFor === currentId) return
      localStorage.setItem(lastFiredKey, currentId || '')
    }
    handleConfetti()
  }, [gameState])

  return (
    <div onClick={handleConfetti} className={styles.party}>

    <span ref={confettiContainer} className={styles.confetti}>

        <span></span>

        <span></span><span></span><span></span><span></span><span></span><span>

        </span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>

    </span>

</div>
  )

}

export default Confetti